import React from 'react'
import { Box, Typography, Collapse, Tooltip } from '@mui/material'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { INTERAX_COLORS, INTERAX_TYPOGRAPHY } from '../../../../constants/colors'
import { MODAL_Z_INDEX } from '../../../../shared/components/DefaultModal'

interface DemographicQuestionCardProps {
  questionNumber: number
  title: string
  tooltip: string
  visible?: boolean
  children: React.ReactNode
}

export const DemographicQuestionCard: React.FC<DemographicQuestionCardProps> = ({
  questionNumber,
  title,
  tooltip,
  visible = true,
  children
}) => {
  const numberLabel = String(questionNumber).padStart(2, '0')

  return (
    <Collapse in={visible} unmountOnExit>
      <Box
        sx={{
          backgroundColor: INTERAX_COLORS.heritageBlue40,
          borderRadius: '12px',
          p: { xs: 2.5, sm: 3 },
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          height: '100%'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: '6px',
              backgroundColor: INTERAX_COLORS.sun,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
          >
            <Typography
              sx={{
                ...INTERAX_TYPOGRAPHY.body3,
                color: INTERAX_COLORS.offBlack,
                fontWeight: 700,
                fontSize: '11px'
              }}
            >
              {numberLabel}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flex: 1, minWidth: 0 }}>
            <Typography
              sx={{
                ...INTERAX_TYPOGRAPHY.body3,
                color: INTERAX_COLORS.white,
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                fontSize: '11px'
              }}
            >
              {title}
            </Typography>
            <Tooltip title={tooltip} placement="top" arrow PopperProps={{ sx: { zIndex: MODAL_Z_INDEX + 1 } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'default', flexShrink: 0 }}>
                <InformationCircleIcon style={{ width: 14, height: 14, color: INTERAX_COLORS.thunderGrey }} />
              </Box>
            </Tooltip>
          </Box>
        </Box>

        {children}
      </Box>
    </Collapse>
  )
}
